export default "__VITE_ASSET__DXvR8d2a__"